import React, { useEffect, useState, useRef } from 'react'
import './Game.css'
import DoneIcon from '@mui/icons-material/Done';

import BottomNavigation from './../Home/BottomNavigation'
import MyLeagueComponent from './MyLeague/MyLeagueComponent';
import TopJoinerComponent from './TopJoiner/TopJoinerComponent';
import HeaderProgressBar from './HeaderProgressBar'
import GetName from './BottomSheets/GetName'
import { useSelector, useDispatch } from 'react-redux'
import Coin from './../Public/Image/Join/Coin.svg'


// import { AllApi } from '../Api/AllApi'

import NoInternet1 from './../Public/Image/Join/NoInternet.svg'
// import { CheckDataBaseGame } from './../GameAction/CheckDataBaseGame'
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';

import {
    SetAppSettingData,
    SetUserLeagueData,
    SetMyLeagueRank,
    SetLeagueLimitJoinProgress,
    SetLeagueMinimumJoinProgress,
    SetRewardLeague,
    SetMyLeagueRankNumber,
    SetGiftTopjoin,
    SetNameAccount,
    SetJoinCountRedux,
    SetPromotionBottomSheet,
    SetUserReward,
    SetClaimRewardCall,
    SetDataClaimReward,
    SetXpLimit,
    SetXpCount,
    SetLevelUserHeaderProgress,
    SetSnackBarEndLeagueState, SetIsBetweenLeaguge
} from './../app/Game'

import { Link } from 'react-router-dom';

import { GameDB } from './../DataBase/GameDB'
import Snackbar from '@mui/material/Snackbar';

import Loading from './../Loading'
import { OnlineRequestAppSettingGame } from '../GameAction/OnlineRequestAppSettingGame'
import { OnlineRequestProfileGame } from '../GameAction/OnlineRequestProfileGame'
import { OnlineRequestLeagueListGame } from '../GameAction/OnlineRequestLeagueListGame'
import { OnlineRequestTopJoinerGame } from '../GameAction/OnlineRequestTopJoinerGame'
import xpplus from './../Public/Image/Join/xpplus.svg'
import { AllApi } from './../Api/AllApi'
import { GetCookie } from '../Action/GetCookie'
import { setUserCoin } from './../app/Home'
import { SetEmail } from './../app/Slice'
import { db } from './../DataBase/db'
import { useHistory } from 'react-router-dom';
import Star from './../Public/Image/Game/Star.svg'
import StarFull from './../Public/Image/Join/Star 8 (1).svg'


import HeadImg from './../../src/Public/Image/Game/Group 26086606.svg'
import { BottomSheet } from 'react-spring-bottom-sheet'
import BronzeImg from './../Public/Image/Game/bronze.svg'
import SilverImg from './../Public/Image/Game/Silver.svg'
import GoldImg from './../Public/Image/Game/Gold.svg'
import PlatinumImg from './../Public/Image/Game/Platinum.svg'
import DiamondImg from './../Public/Image/Game/Diamond.svg'
import EpicImg from './../Public/Image/Game/Epic.svg'
import LegendryImg from './../Public/Image/Game/Legendry.svg'
import MasterImg from './../Public/Image/Game/Master.svg'
import GrandMasterImg from './../Public/Image/Game/GrandMaster.svg'
import LordImg from './../Public/Image/Game/Lord.svg'
import CreatorImg from './../Public/Image/Game/Creator.svg'
const Game = () => {
    const dispatch = useDispatch()
    // const [MyLeague, setMyLeague] = useState(false)
    const [MyLeague, setMyLeague] = useState(true)
    const GameLoading = useSelector((state) => state.Game.GameLoading)
    const MyLeagueRankNumber = useSelector((state) => state.Game.MyLeagueRankNumber)
    const history = useHistory();
    const CountJoining = useSelector((state) => state.JoinState.CountJoining)

    const UserCoin = useSelector((state) => state.Home.UserCoin)
    const [RemainJoin, setRemainJoin] = useState('')

    const JoinCountRedux = useSelector((state) => state.Game.JoinCountRedux)
    const UserLeagueData = useSelector((state) => state.Game.UserLeagueData)
    const ClaimRewardCall = useSelector((state) => state.Game.ClaimRewardCall)
    const MyLeagueRank = useSelector((state) => state.Game.MyLeagueRank)
    const TopJoinerTime = useSelector((state) => state.Game.TopJoinerTime)
    const IsBetweenLeaguge = useSelector((state) => state.Game.IsBetweenLeaguge)
    const xpCountLeague = useSelector((state) => state.Game.xpCountLeague)
    const XpMax = useSelector((state) => state.Game.XpMax)
    const [LoadState, setLoadState] = useState(false)
    const [LastUpdate, setLastUpdate] = useState(0)
    const [NoInternet, setNoInternet] = useState(false)
    // const [IsBetweenLeaguge, setIsBetweenLeaguge] = useState(null)
    const [runInterval, setRunInterval] = useState(false);
    const [LastTime, setLastTime] = useState(0);
    const [CashTime, setCashTime] = useState(0);
    const intervalRef = useRef(null);
    const [League, setLeague] = useState('')
    const [Rank, setRank] = useState('')
    const [ForStyle, setForStyle] = useState('')
    const [IsCreator1, setIsCreator1] = useState(false)

    const Style = {
        Bronze: {
            img: BronzeImg,
            imgBg: '#BF897066',
            Rank: '#BF897033',
            Rank2: '#321203',
            Rank3:"#FFEDE6",
            Progress: '#BF8970',
            ListBorder: '#BF8970',
            ListTitleBg: '#BF8970',
            ListTitleText: '#321203',
            ListTitleYou: '#4B2714',
            ListTitleYouBg: '#FFEDE6',
            ListBodyBg: '#FFEDE6',
            ListBodyText: '#321203'
        },
        Silver: {
            img: SilverImg,
            imgBg: '#8E9FAF66',
            Rank: '#8E9FAF33',
            Rank2:"#22323F",
            Rank3:"#FFFFFF",
            Progress: '#8E9FAF',
            ListBorder: '#8E9FAF',
            ListTitleBg: '#8E9FAF',
            ListTitleText: '#22323F',
            ListTitleYou: '#22323F',
            ListTitleYouBg: '#F3F3F3',
            ListBodyBg: '#F3F3F3',
            ListBodyText: '#22323F'
        },
        Gold: {
            img: GoldImg,
            imgBg: '#FFD10066',
            Rank: '#FFD41233',
            Rank2: '#8F4F2C',
            Rank3: '#FFFFFF',
            Progress: '#FFD100',
            ListBorder: '#FFD100',
            ListTitleBg: '#FFD100',
            ListTitleText: '#3C2F00',
            ListTitleYou: '#3C2F00',
            ListTitleYouBg: '#FFF0C9',
            ListBodyBg: '#FFF0C9',
            ListBodyText: '#3C2F00'
        },
        Platinum: {
            img: PlatinumImg,
            imgBg: '#ACB2AC66',
            Rank: '#B1B8B133',
            Rank2: '#373D37',
            Rank3: '#FFFFFF',
            Progress: '#ACB2AC',
            ListBorder: '#ACB2AC',
            ListTitleBg: '#ACB2AC',
            ListTitleText: '#2C322E',
            ListTitleYou: '#2C322E',
            ListTitleYouBg: '#DEE4DD',
            ListBodyBg: '#2C322E',
            ListBodyText: '#424844'
        },
        Diamond: {
            img: DiamondImg,
            imgBg: '#B3ECF966',
            Rank: '#B3ECF933',
            Rank2: '#00363E',
            Rank3: '#FFFFFF',
            Progress: '#B9F2FF',
            ListBorder: '#B9F2FF',
            ListTitleBg: '#B9F2FF',
            ListTitleText: '#00363E',
            ListTitleYou: '#2C322E',
            ListTitleYouBg: '#EDFCFF',
            ListBodyBg: '#00363E',
            ListBodyText: '#0B4E59'
        },
        Epic: {
            img: EpicImg,
            imgBg: '#8C49CA66',
            Rank: '#8C49CA33',
            Rank2: '#2C0050',
            Rank3: '#FFFFFF',
            Progress: '#8C49CA',
            ListBorder: '#8C49CA',
            ListTitleBg: '#8C49CA',
            ListTitleText: '#FAECFF',
            ListTitleYou: '#4A007F',
            ListTitleYouBg: '#FAECFF',
            ListBodyBg: '#2C0050',
            ListBodyText: '#4A007F'
        },
        Legendary: {
            img: LegendryImg,
            imgBg: '#C0002166',
            Rank: '#C0002133',
            Rank2: '#410005',
            Rank3: '#FFFFFF',
            Progress: '#C00021',
            ListBorder: '#C00021',
            ListTitleBg: '#C00021',
            ListTitleText: '#FFEDEB',
            ListTitleYou: '#68000D',
            ListTitleYouBg: '#FFEDEB',
            ListBodyBg: '#410005',
            ListBodyText: '#68000D'
        },
        Master: {
            img: MasterImg,
            imgBg: '#5656FF66',
            Rank: '#5656FF33',
            Rank2: '#00006E',
            Rank3: '#FFFFFF',
            Progress: '#5656FF',
            ListBorder: '#5656FF',
            ListTitleBg: '#5656FF',
            ListTitleText: '#FFFBFF',
            ListTitleYou: '#1300A9',
            ListTitleYouBg: '#F2EFFF',
            ListBodyBg: '#08006C',
            ListBodyText: '#00006E'
        },
        Grandmaster: {
            img: GrandMasterImg,
            imgBg: '#0202A966',
            Rank: '#1212A333',
            Rank2: '#00006E',
            Rank3: '#FFFFFF',
            Progress: '#0202D3',
            ListBorder: '#0202D3',
            ListTitleBg: '#0202D3',
            ListTitleText: '#E0E0FF',
            ListTitleYou: '#0202A9',
            ListTitleYouBg: '#E0E0FF',
            ListBodyBg: '#00006E',
            ListBodyText: '#0202A9'
        },
        Lord: {
            img: LordImg,
            imgBg: '#006C4466',
            Rank: '#006C4433',
            Rank2: '#003921',
            Rank3: '#FFFFFF',
            Progress: '#006C44',
            ListBorder: '#006C44',
            ListTitleBg: '#006C44',
            ListTitleText: '#C0FFD7',
            ListTitleYou: '#005232',
            ListTitleYouBg: '#C0FFD7',
            ListBodyBg: '#003921',
            ListBodyText: '#005232'
        },
        Creator: {
            img: CreatorImg,
            imgBg: '#21212166',
            Rank: '#21212133',
            Rank2: '#212121',
            Rank3: '#FFFFFF',
            Progress: '#212121',
            ListBorder: '#212121',
            ListTitleBg: '#212121',
            ListTitleText: '#FFFFFF',
            ListTitleYou: '#212121',
            ListTitleYouBg: '#FFFFFF',
            ListBodyBg: '#212121',
            ListBodyText: '#212121'
        },
    }
   
    const [NextTargetLeague, setNextTargetLeague] = useState(false)
    useEffect(() => {
        const loadData = async () => {
            const AppSetting = await GameDB.AppSetting.toArray();

            const LeagesInAppSetting = AppSetting[0].AppSetting.leagues

            for (let index = 0; index < LeagesInAppSetting.length; index++) {
                const item = LeagesInAppSetting[index];
                if (item.leagueLevel == MyLeagueRankNumber) {
                    if (item.leagueLevel == 33) {
                        setNextTargetLeague(LeagesInAppSetting[index].leagueName)
                    }
                    setNextTargetLeague(LeagesInAppSetting[index + 1].leagueName)
                }

            }

            setLoadState(true);

            const leagues = [
                'Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond',
                'Epic', 'Legendary', 'Master', 'Grandmaster', 'Lord', 'Creator'
            ];

            for (const leagueName of leagues) {
                // console.log(MyLeagueRank)
                // console.log(leagueName)
                if (MyLeagueRank.includes(leagueName)) {
                    setLeague(leagueName);
                //   console.log(Style[leagueName])
                    setForStyle(Style[leagueName]);

                    const rank = MyLeagueRank.replace(leagueName, '').trim();
                    setRank(rank);

                    if (leagueName === 'Creator') {
                        setIsCreator1(rank === 'I');
                    } else {
                        setIsCreator1(false);
                    }

                    break;
                }
            }

            setTimeout(() => {
                setLoadState(false);
            }, 2000);
        };

        loadData();
    }, [MyLeagueRank]);
    // console.log(Rank)
    // SnackBar /////////////////////////
    const [state, setState] = React.useState({
        opens: false,
        vertical: 'top',
        horizontal: 'center',
    });
    const { vertical, horizontal, opens } = state;
    const handleClick = (newState) => {
        setState({ ...newState, opens: true });
    };
    const handleClose = () => {
        setState({ ...state, opens: false });
    };
    const [open, setOpen] = useState(false)

    function onDismiss() {
        setTimeout(() => {
            setOpen(false)
        }, 300);
    }
    // // SnackBar//////////////////////////////


    useEffect(() => {

        if (NoInternet == true) {

            const timer = setInterval(async () => {
                let IsOnline = window.navigator.onLine

                if (IsOnline == true) {
                    clearInterval(timer);
                    // StartGame()

                }
            }, 10000);

        }
    }, [NoInternet])


    useEffect(() => {

        if (runInterval) {
            intervalRef.current = setInterval(() => {
                let NowInNow = new Date().getTime();
                let LastTimeLeague = localStorage.getItem('LastTimeLeague')
                let Distance = LastTimeLeague - NowInNow;
                // var minutescashTime = Math.floor(CashTime / 60);
                var minutes = Math.floor((Distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((Distance % (1000 * 60)) / 1000);


                if (minutes < 0) {
                    setLastUpdate(Math.abs(minutes))
                } else {
                    setLastUpdate(false)

                }
            }, 1000);
        }

        return () => {
            clearInterval(intervalRef.current);
        }; // clear interval when unmounting the component
    }, [runInterval, LastTime, CashTime]);





    const OfflineRequestLeagueList = async () => {


        let LeagueList = await GameDB.LeagueList.toArray()
        if (LeagueList.length > 0) {

            dispatch(SetUserLeagueData(LeagueList[0].LeagueList.data))
            dispatch(SetLevelUserHeaderProgress(LeagueList[0].LeagueList))
            let LevelUser = false
            LevelUser = LeagueList[0].LeagueList.data.userInformation.leagueLevel

            // let ResOfCalc = await GetUserDataFromAppSetting(LevelUser)


            let cacheTime = LeagueList[0].LeagueList.data.cacheTime
            let LastTime = LeagueList[0].LastTime
            clearInterval(intervalRef.current);
            localStorage.setItem('LastTimeLeague', LastTime)
            setLastTime(LastTime)
            setCashTime(cacheTime)
            setRunInterval(true)
        } else {

            // setNoInternet(true)
            const timer = setInterval(async () => {
                LeagueList = await GameDB.LeagueList.toArray()

                if (LeagueList.length == 1) {
                    clearInterval(timer);
                    OfflineRequestLeagueList()
                    // setNoInternet(false)
                } else {

                }

            }, 1000);

        }

    }




    useEffect(() => {

        OfflineRequestLeagueList()

        return () => {

        }
    }, [IsBetweenLeaguge])



    useEffect(() => {

        // localStorage.setItem("BadgeForGame", "game")

    }, [IsBetweenLeaguge, UserLeagueData])


    useEffect(() => {
        GetProfileFunction()
    }, [UserCoin])

    const Token = GetCookie('Token');

    const [PointDialogState, setPointDialogState] = useState('')
    const [xpCount, setxpCount] = useState('')
    const [xpLevel, setxpLevel] = useState('')
    const [xpLimit, setxpLimit] = useState('')
    const GetProfileFunction = async () => {
        const MakeApiClass = new AllApi();

        let AppSetting = await GameDB.AppSetting.toArray()

        if (AppSetting.length > 0) {
            setPointDialogState(AppSetting[0].AppSetting.PointDialog)

            let res = await MakeApiClass.GetProfile(Token)

            setxpCount(res.data.user.xpCount)
            setxpLevel(res.data.user.xpLevel)
            setxpLimit(res.data.user.xpLimit)
            if (res.code == 200) {
                dispatch(setUserCoin(res.data.user.coins))
                let res1 = db.Data.where({ id: Number(1) }).modify({ Email: res.data.user.email })
                dispatch(SetEmail(res.data.user.email))

            } else if (res.code == 120 || res.code == 121 || res.code == 122 || res.code == 123) {
                // console.log(234)
                let name = "Token"
                let name1 = "active"
                document.cookie = name + '=; Max-Age=-99999999;';
                document.cookie = name1 + '=; Max-Age=-99999999;';
                // console.log(234)

                history.push("/");
                // dispatch(setLoading(false))

            }
        } else {
            GetProfileFunction()
        }


    }
    // const OpenBottomSheetShowXpDetails = () => {
    //     setBottomSheetState(true)
    // }
    // const [BottomSheetState, setBottomSheetState] = useState(false)
    // function onDismiss() {
    //     setTimeout(() => {
    //         setBottomSheetState(false)
    //     }, 300);

    // }

    function abbreviate_number(num) {
        if (num === null || num === undefined || num === false) return null;
        if (num === 0) return '0';

        let k = Math.floor((Math.log10(num)) / 3); // تعیین مقیاس (K, M, B, T)
        let scale = Math.pow(10, k * 3); // مقدار مقیاس برای تقسیم عدد
        let shortened = num / scale; // عدد را مقیاس‌بندی می‌کنیم

        return shortened.toFixed(1).replace(/\.0$/, '') + ['', 'K', 'M', 'B', 'T'][k]; // حذف `.0` از اعداد صحیح
    }
// console.log(ForStyle)
    return (
        <>
            {/* <BottomSheet onDismiss={onDismiss} open={BottomSheetState}>
                <div className='RegisterBeforeBottomSheet'>
                    <div className='RegisterBeforeBottomSheetHeader'>
                        <div className='HeaderLogoBottomSheet' >
                            {xpCountLeague == 0 || xpCountLeague == 1 ?
                                "Point"
                                :
                                "Points"
                            }  in this event:
                            <b style={{ margin: "0 4px 0 4px" }}>
                                {xpCountLeague > 0 ? xpCountLeague.toLocaleString() : 0}
                            </b>
                            <img src={xpplus} className='XpCountInlistIcon' style={{ "width": "14px", "height": "14px" }} />

                        </div>

                    </div>
                    <div className='HeaderLogoBottomSheetText' >
                        How can we get Points?

                    </div>
                    <ul className='BottomSheetUlXpUl'>
                        {
                            PointDialogState ?
                                PointDialogState.map((item, i) =>
                                    <li key={i} style={{ "marginTop": "8px" }}>{item}</li>
                                )
                                : null
                        }

                    </ul>

                    <div className='RegisterBeforeBottomSheetFooter'>
                        <Link to="/Profile" className='BottomSheetCancelButton'  >Show All pts</Link>
                        <button className="BottomSheetLoginButton" onClick={() => setBottomSheetState(false)}>Got it</button>

                    </div>
                </div>
            </BottomSheet> */}
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={opens}
                onClose={handleClose}
                onDismiss={onDismiss}
                message="Something went wrong"
                key={vertical + horizontal}
                autoHideDuration={3000}
            />
            {
                !GameLoading ?
                    NoInternet ?
                        <>
                            <div className='JoinContainer'>
                                <div className='NoInterNetLogo'>
                                    <img src={NoInternet1} />
                                </div>
                                <div className='NoInterNetText'>
                                    Please make sure your device is connected to the internet
                                </div>
                                <div className='NoInterNetButton'>
                                    <button onClick={() => window.location.reload()}>
                                        Retry
                                    </button>
                                </div>

                            </div>
                        </>

                        :
                        IsBetweenLeaguge != null ?
                            UserLeagueData.topUsers ?
                                <div className='Game'>
                                    <div className='GameHeader'>
                                        <div className='GameHeaderInner'>
                                            <div className='HeaderLogo' style={{ backgroundColor: ForStyle.Rank }} 
                                            // onClick={() => OpenBottomSheetShowXpDetails()}
                                            >

                                                <div className='HeaderLogoPt'>
                                                    <div className='GameCupImgContainer'>
                                                        <img src={ForStyle.img} style={{ background: ForStyle.imgBg, borderRadius: '33px', width: "35px", height: "35px",padding:"2px",marginTop:"3px" }} className='GameCupImg' />
                                                        <div className='GameLeagueNameNew' style={{ backgroundColor: ForStyle.Rank2,color:ForStyle.Rank3 }} >{Rank} </div>
                                                    </div>


                                                    <span className='HeaderLogoPtInner' style={{ marginLeft: "8px", color: ForStyle.ListBodyText ,height:"34px"}} >
                                                        <span className='PtLogoAndHeaderLogoPtInner' >
                                                           
                                                            {  abbreviate_number(XpMax - xpCountLeague)}
                                                            <img src={StarFull} className='HeaderProgressBarImg' style={{width:"10px",height:"10px"}} />
                                                        </span>
                                                        to
                                                        {" " + NextTargetLeague}

                                                    </span>

                                                </div>
                                            </div>
                                         
                                            <Link to="/Coin?Status=Join" className='HeaderCoin'>
                                               
                                                {/* <AddCircleRoundedIcon className='AddCoinIcon' /> */}
                                                <div>
                                                    {UserCoin.toLocaleString()}
                                                </div>
                                                <div className='HeaderCoinImgContainer'>

                                                    {
                                                        CountJoining > 0 ?
                                                            <>
                                                                <div className='CoinHeaderImageLoader'></div>
                                                                <img src={Coin} className='HeaderCoinImg1' />
                                                            </>

                                                            :
                                                            <img src={Coin} className='HeaderCoinImg1' />

                                                    }

                                                </div>
                                               
                                            </Link >
                                        </div>

                                    </div>

                                    <div className='GameContent'>

                                        {
                                            // !IsBetweenLeaguge ?
                                            <div className='GameChips'>
                                                {/* 
                                                <div className={!MyLeague ? 'GameChipsItemLeft noSelect ActiveChips' : 'GameChipsItemLeft noSelect'} onClick={() => setMyLeague(false)}>
                                                    {!MyLeague ? <span><DoneIcon className={'GameChipsDone'} /></span> : null}
                                                    Top Players
                                                </div>

                                                <div className={MyLeague ? 'GameChipsItemRight noSelect ActiveChips' : 'GameChipsItemRight noSelect'} onClick={() => setMyLeague(true)}>
                                                    {MyLeague ? <span><DoneIcon className={'GameChipsDone'} /></span> : null}
                                                    My League
                                                </div> */}




                                                <div className={MyLeague ? 'GameChipsItemLeft noSelect ActiveChips' : 'GameChipsItemLeft noSelect'} onClick={() => setMyLeague(true)}>
                                                    {MyLeague ? <span><DoneIcon className={'GameChipsDone'} /></span> : null}
                                                    My League
                                                </div>


                                                <div className={!MyLeague ? 'GameChipsItemRight noSelect ActiveChips' : 'GameChipsItemRight noSelect'} onClick={() => setMyLeague(false)}>
                                                    {!MyLeague ? <span><DoneIcon className={'GameChipsDone'} /></span> : null}

                                                    Top Joiners
                                                </div>
                                            </div>
                                            // : null
                                        }


                                        <div className='SelectComponent'>
                                            {

                                                MyLeague ?

                                                    <MyLeagueComponent MyLeagueRank={MyLeagueRank} LastUpdate={LastUpdate} />
                                                    :
                                                    <TopJoinerComponent IsBetweenLeaguge={IsBetweenLeaguge} Time={TopJoinerTime} LastUpdate={LastUpdate} />
                                            }




                                        </div>
                                        <GetName />
                                    </div>
                                    <div className='GameFooter'>

                                        <BottomNavigation />

                                    </div>
                                </div>

                                : <Loading />
                            : <Loading />
                    : <Loading />

            }

        </>
    )
}


export default Game